import { t } from 'i18next';
import { PASSWORD_REGEX } from 'regexConstants';
import { VALID } from 'validations';

const passwordValidate = (errorMsg?: string) => (value: string) => {
  if (!value) return VALID;
  return value && PASSWORD_REGEX.test(value)
    ? VALID
    : errorMsg || t('password-validation-message');
};

export default { passwordValidate };
